<script>
	export let teams;
</script>

<div class="teams">
	{#each teams as team}
		<div class="team">
			<h1>{team.name}</h1>
			<p>{team.player}</p>
			<img src="imgs/player/{team.id}.jpg" alt={teams.player} />
		</div>
	{/each}
</div>

<style>
	.teams {
		display: grid;
		width: 100%;
		grid-template-columns: repeat(4, 1fr);
		align-items: flex-end;
		justify-items: center;
	}
	.team {
		width: 200px;
	}
	img {
		max-width: 100%;
	}
</style>
